import Button from '@gds/Button/Button';
import { Tick } from '@gds/Icons/Paths/Tick';

import { IMAGES_360_TAB_NAME, IMAGES_TAB_NAME, VIDEO_TAB_NAME } from './Gallery.constants';
import type { GalleryTabsProps } from './Gallery.entity';

import styles from './Gallery.module.css';

export const GalleryTabs = ({
  activeTab,
  switchTab,
  strings,
  hasVideo,
  has360Images,
}: GalleryTabsProps) => {
  const hasMultipleTabs = hasVideo || has360Images;
  return (
    <div className={styles.galleryTabs}>
      {hasMultipleTabs && (
        <Button
          aria-label="images button"
          variant="contained"
          onClick={() => switchTab(IMAGES_TAB_NAME)}
          leftIcon={activeTab === IMAGES_TAB_NAME ? <Tick /> : null}
        >
          {strings.imagesCta}
        </Button>
      )}
      {hasVideo && (
        <Button
          aria-label="video button"
          variant="contained"
          onClick={() => switchTab(VIDEO_TAB_NAME)}
          leftIcon={activeTab === VIDEO_TAB_NAME ? <Tick /> : null}
        >
          {strings.videoCta}
        </Button>
      )}

      {has360Images && (
        <Button
          aria-label="360 images button"
          variant="contained"
          onClick={() => switchTab(IMAGES_360_TAB_NAME)}
          leftIcon={activeTab === IMAGES_360_TAB_NAME ? <Tick /> : null}
        >
          {strings.images360}
        </Button>
      )}
    </div>
  );
};
